import ApiService from "@/common/api/api.service";

export const SocialService = {


    list() {
        ApiService.setHeader()
        return ApiService.get('socials')
    },
    
    get(slug) {
        ApiService.setHeader()
        return ApiService.get('social', slug)
    },
    
    create(data) {
        ApiService.setHeader()
        return ApiService.post('social', data)
    },
    update(slug, data) {
        ApiService.setHeader()
        return ApiService.update('social', slug, data)
    },
    delete(slug) {
        ApiService.setHeader()
        return ApiService.delete(`social/${slug}`)
    }
}